const PropertyAmenities = ({ amenityGroups = [] }) => {
  if (!amenityGroups.length) {
    return null;
  }

  return (
    <section className="property-detail-section" aria-label="Features and amenities">
      <h2 className="property-detail-section__title">Features &amp; amenities</h2>
      <div className="property-detail-amenities">
        {amenityGroups.map((group) => (
          <div key={group.group} className="property-detail-amenities__group">
            <h3>{group.group}</h3>
            <ul>
              {group.values.map((value) => (
                <li key={value}>
                  <span className="property-detail-pill">{value}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PropertyAmenities;
